import React from 'react'
import { useIntl } from 'react-intl'
import { ImageText, Table } from 'msp-components'
import { Region } from 'msp-integrations'
import { ProductDetailsProps } from './JasminProductDetails.types'
import {
  getTeaProperties,
  getIngredientsAndAllergens
} from './JasminProductDetails.utils'

const JasminProductDetails = ({
  product: {
    name,
    c_caffeine,
    c_specialties,
    c_aromatisation,
    c_origin,
    c_ingredients,
    c_allergens,
    c_teaDescription2Headline,
    c_teaDescription2,
    c_daytime,
    c_aromaticAssociation
  },
  imagePosition = 'right',
  bgStyle = 'light',
  imageSrc = '',
  imageAlt,
  content
}: ProductDetailsProps) => {
  const { formatMessage } = useIntl()

  const teaProperties = getTeaProperties({
    c_caffeine,
    c_specialties,
    c_aromatisation,
    c_origin,
    c_daytime,
    c_aromaticAssociation
  })

  const ingredientsAndAllergens = getIngredientsAndAllergens({
    c_ingredients,
    c_allergens
  })

  const lineTitleClasses = 'font-Lora font-bold'
  const lineKeyClasses = 'font-Roboto font-medium text-15'
  const lineValueClasses = 'font-Roboto'

  return (
    <ImageText
      background={bgStyle}
      imagePosition={imagePosition}
      imageUrl={imageSrc}
      imageAlt={imageAlt || `${name} Details`}
    >
      <div className='mx-auto flex min-w-[100%] max-w-xl flex-col'>
        <div className='mb-2 md:mb-6'>
          {!!c_teaDescription2Headline && (
            <h2 className='headline-h3 mb-4 block text-left md:mb-6'>
              {c_teaDescription2Headline}
            </h2>
          )}
          {!!c_teaDescription2 && (
            <span
              className='font-Roboto text-16 tracking-0 font-thin'
              dangerouslySetInnerHTML={{
                __html: c_teaDescription2.replace(/\r\n/g, '<br/>')
              }}
            />
          )}
        </div>
        {content && (
          <div className='mb-2 h-fit w-full md:mb-6'>
            <Region region={content} />
          </div>
        )}
        {teaProperties.length > 0 && (
          <div className='mt-8 md:mt-0'>
            <Table
              title={formatMessage({
                id: 'msp.product.benefits.characteristics',
                defaultMessage: 'Characteristics'
              })}
              fields={teaProperties}
              titleClasses={lineTitleClasses}
              fieldKeyClasses={lineKeyClasses}
              fieldValueClasses={lineValueClasses}
            />
          </div>
        )}
        {ingredientsAndAllergens.length > 0 && (
          <div className='mt-8 md:mt-0' id='ingredients'>
            <h2
              className={`headline-h3 mb-4 block text-left md:mb-6 ${lineTitleClasses}`}
            >
              {formatMessage({
                id: 'msp.product.benefits.title',
                defaultMessage: 'Ingredients'
              })}
            </h2>
            {ingredientsAndAllergens.map(({ key, value }, index) => (
              <div className='mb-5' key={index}>
                <span
                  className={`my-auto flex w-1/2 text-left tracking-[0.6px] ${lineKeyClasses}`}
                >
                  {key}
                </span>
                <span
                  className={`text-15 my-auto flex w-1/2 text-left tracking-[0.6px] ${lineValueClasses} font-thin`}
                  dangerouslySetInnerHTML={{
                    __html: value.replace(/\r\n/g, '<br/>')
                  }}
                />
              </div>
            ))}
          </div>
        )}
      </div>
    </ImageText>
  )
}
export default JasminProductDetails
